export default function SpendingDashboard({ spending, disabled }) {
  if (!spending) return null;

  const daily = spending.daily || {};
  const spentToday = daily.spent || 0;
  const dailyLimit = daily.limit || 200;
  const txCount = spending.tx_count || 0;
  const remaining = Math.max(0, dailyLimit - spentToday);
  const pct = dailyLimit > 0 ? (spentToday / dailyLimit) * 100 : 0;
  const isHigh = pct > 80;

  return (
    <div
      className={`mcp-spending-dashboard ${disabled ? "mcp-disabled-section" : ""}`}
    >
      <h5 className="mcp-subsection-title">Today's spending</h5>
      <div className="mcp-spending-stats">
        <div className="mcp-stat">
          <span className="mcp-stat-label">Spent today</span>
          <span className="mcp-stat-value">${spentToday.toFixed(2)}</span>
        </div>
        <div className="mcp-stat">
          <span className="mcp-stat-label">Daily limit</span>
          <span className="mcp-stat-value">${dailyLimit.toFixed(2)}</span>
        </div>
        <div className="mcp-stat">
          <span className="mcp-stat-label">Remaining</span>
          <span className="mcp-stat-value">${remaining.toFixed(2)}</span>
        </div>
        <div className="mcp-stat">
          <span className="mcp-stat-label">Transactions</span>
          <span className="mcp-stat-value">{txCount}</span>
        </div>
      </div>
      <div className="mcp-progress-bar">
        <div
          className={`mcp-progress-fill ${isHigh ? "mcp-progress-danger" : ""}`}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
      <span className="mcp-progress-pct">{Math.round(pct)}% used</span>
    </div>
  );
}
